module.exports = __webpack_public_path__ + "img/32.bfb7b739.jpg";